module.exports = __webpack_public_path__ + "img/case-1.4c2c77bd.png";